const yup = require("yup");
const vals = ["organiser", "host"];
module.exports = yup
  .string()
  .oneOf(vals)
  .required("Which type of user you are");
